<template>
  <v-container>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Thông tin tiến độ</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">Thông tin sản xuất</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 3" step="3">Thông tin tài chính</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 4" step="4">Thông tin vận chuyển và quà tặng</v-stepper-step>

        <v-divider v-if="isFreelancer || requestMethod === 2"></v-divider>
        <v-stepper-step :complete="e1 > 5" step="5" v-if="isFreelancer || requestMethod === 2">Upload file thiết kế
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container v-if="e1 === 1">
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="6" class="pr-2">
                <v-col>
                  <v-dialog ref="dialog" v-model="modal" :return-value.sync="deadline" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="computedDateFormatted"
                                    v-bind:label="$t('manufacture_item.manufacture_date')" hide-details readonly
                                    v-on="on" outlined dense>
                        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on">info</v-icon>
                          </template>
                          <span>Chọn ngày sẽ hoàn thành sản xuất</span>
                        </v-tooltip>
                      </v-text-field>
                      <span class="hintFont"> Thời gian được yêu cầu sản xuất là: <b>{{ durationManufacture }} ngày</b>(Không tính chủ nhật)</span>
                    </template>
                    <v-date-picker v-model="deadline" scrollable locale="vi">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }}</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(deadline)"> {{ $t('common.ok') }}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col>
                  <!-- <v-autocomplete v-model="selectOrderType" :items="orderTypes" item-text="name" v-bind:label="$t('manufacture_item.order_type')" outlined return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                          <template v-slot:activator="{ on }">
                              <v-icon color="primary" dark v-on="on">info</v-icon>
                          </template>
                          <span>Chọn phân loại tính chất đơn hàng</span>
                      </v-tooltip>
                  </v-autocomplete> -->
                  <v-radio-group v-model="shipType" hide-details>
                    <template v-slot:label>
                      <span class="titleFont mb-5"><b>Lựa chọn phương án ship</b></span>
                    </template>
                    <v-radio :value="1">
                      <template v-slot:label>
                        <div>Chuyển phát nhanh miền Bắc (<b>1-2 ngày</b>).</div>
                      </template>
                    </v-radio>
                    <v-radio :value="2">
                      <template v-slot:label>
                        <div>Chuyển phát nhanh miền Trung, Nam (<b>3-4 ngày</b>).</div>
                      </template>
                    </v-radio>
                    <v-radio :value="3">
                      <template v-slot:label>
                        <div>Hỏa tốc miền Trung, Nam (<b>1-2 ngày</b>), phụ thu 400k.</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                  <span class="hintFont"> Thời gian nhận áo dự kiến: <b>Ngày {{ receiveDateString }}.</b></span>
                </v-col>
              </v-col>
              <v-col cols="12" sm="6" class="pl-2">
                <v-col>
                  <span class="titleFont"><b>THÔNG BÁO TỪ CÔNG TY ĐỢT CAO ĐIỂM</b></span> <br/>

                  <span> Thông báo thời gian ship chuyển phát nhanh đợt cao điểm 20/11 và 26/3: </span> <br/>
                  <span> - Nội thành Hà Nội: 1 ngày. </span> <br/>
                  <span> - Ngoại thành Hà Nội + Các tỉnh miền Bắc lân cận Hà Nội (Thái Nguyên, Hải Phòng, Bắc Ninh,...): 2-3 ngày. </span>
                  <br/>
                  <span> - Các tỉnh miền Nam, miền Trung: 2-3 ngày (Đối với các thành phố lớn như Đà Nẵng, HCM,...), 3-4 ngày (Đối với các khu vực huyện, xã, thôn). </span>
                  <br/> <br/>
                  <span> Ship hỏa tốc 1-2 ngày toàn quốc: Ship máy bay hỏa tốc hoặc gửi xe khách. Khách cần đóng thêm phí chênh lệch. </span>
                  <br/> <br/>
                  <span> *Lưu ý: </span> <br/>
                  <span> - Thời gian vận chuyển trên chỉ là thời gian dự kiến, có thể sai lệch 1-2 ngày tùy thuộc và đơn vị vận chuyển. </span>
                  <br/>
                </v-col>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="close">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkInforProgress" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>

        </v-stepper-content>

        <v-stepper-content step="2">
          <v-container align="center" v-if="e1 === 2">
            <v-row align="center" justify="start">
              <v-col v-for="detail in detailProfiles" :key="detail._id" cols="12" sm="6">
                <v-card>
                  <v-row no-gutters>
                    <v-col cols="12" sm="5">
                      <v-img :src="getImageProduct(detail)" aspect-ratio="0.8" lazy-src='@/assets/noimage.png'/>
                    </v-col>
                    <v-col cols="12" sm="7">
                      <v-card flat>
                        <!-- <v-card-title v-text="createHeaderStyle(detail)"></v-card-title> -->
                        <v-card-text>
                          {{ $t('manufacture_dialog.form_style') }} {{ detail.formStyle.name }} <br/>
                          {{ $t('manufacture_dialog.material_style') }} {{ createMaterialStyleString(detail) }} <br/>
                          {{ $t('manufacture_dialog.number') }} {{
                            thousandSeprator(calculateTotalSizeOfProduct(detail))
                          }} chiếc<br/>
                          {{ $t('manufacture_dialog.gift_number') }} {{ thousandSeprator(detail.giftNumber) }}
                          chiếc<br/>

                          <span v-for="profile in detail.profilesInfo" :key="profile._id">
                                                        - {{ generateProfileSizes(profile) }} <br/>
                                                    </span>
                          <span> {{ $t('manufacture_dialog.price') }} <span
                              class="numberFont">{{ thousandSeprator(detail.price) }}</span>đ / sản phẩm </span> <br/>
                          <span> {{ $t('manufacture_dialog.total_money_product') }} <span class="numberFont">{{
                              thousandSeprator(calculateTotalMoneyOfProduct(detail))
                            }}</span>đ </span><br/>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                            <template v-slot:activator="{ on }">
                              <v-btn icon>
                                <v-icon v-on="on" @click="editProductInfor(detail)">edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Chỉnh sửa thông tin sản phẩm</span>
                          </v-tooltip>

                          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                            <template v-slot:activator="{ on }">
                              <v-btn icon>
                                <v-icon v-on="on" @click="deleteProductInfor(detail)">mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Xóa sản phẩm</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12">
                <v-divider></v-divider>

                <v-row class="pt-4 pr-4">
                  <v-spacer></v-spacer>
                  <span> Tổng tiền: <span class="totalFont"> {{ thousandSeprator(calculateTotalMoneyOfAll()) }} </span> đ</span>
                </v-row>
              </v-col>

              <v-col cols="12" align="center" justify="center">
                <v-btn color="primary" width="200px" @click="addProductionInfor"> Thêm sản phẩm</v-btn>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkAddProductionInfor" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-container align="center" v-if="e1 === 3">
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="5" class="pr-2">
                <v-row align="start" no-gutters>
                  <v-col cols="12">
                    <v-numeric-field v-model="manufactureRequest.subTotal"
                                     v-bind:label="$t('manufacture_item.total_cost')" outlined readonly dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Thông tin tổng số tiền</span>
                      </v-tooltip>
                    </v-numeric-field>
                  </v-col>

                  <v-col cols="12">
                    <v-numeric-field v-model="prepay" v-bind:label="$t('manufacture_item.prepay')" outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Thông tin số tiền khách hàng đã đặt cọc</span>
                      </v-tooltip>
                    </v-numeric-field>
                  </v-col>

                  <v-col cols="12">
                    <v-numeric-field v-model="vat" v-bind:label="$t('manufacture_item.vat')" outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Nhập thông tin % VAT</span>
                      </v-tooltip>
                    </v-numeric-field>
                  </v-col>

                  <v-col cols="12">
                    <v-numeric-field v-model="discount" v-bind:label="$t('manufacture_item.discount')" outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Thông tin số tiền chiết khấu</span>
                      </v-tooltip>
                    </v-numeric-field>
                  </v-col>

                  <v-col cols="12">
                    <v-numeric-field v-model="additionCost" v-bind:label="$t('manufacture_item.addition_cost')" outlined
                                     dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Thông tin số tiền phụ thu</span>
                      </v-tooltip>
                    </v-numeric-field>
                  </v-col>

                  <v-col cols="12">
                    <v-checkbox v-model="isTag" v-bind:label="$t('manufacture_item.tag')" dense></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="7" class="pl-2">
                <v-row align="start" no-gutters>
                  <v-col cols="12">
                    <v-textarea v-model="manufactureRequest.discountNote"
                                v-bind:label="$t('manufacture_item.note_discount')" outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Giải thích số tiền chiết khấu</span>
                      </v-tooltip>
                    </v-textarea>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea v-model="manufactureRequest.additionCostNote"
                                v-bind:label="$t('manufacture_item.note_addtion')" outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Giải thích lý do phụ thu</span>
                      </v-tooltip>
                    </v-textarea>
                  </v-col>

                  <v-col cols="12">
                    <upload-dialog @uploadFileSuccess="uploadFileProofSuccess"></upload-dialog>
                    <v-row v-for="file in proofImages" :key="file.id">
                      <v-col cols="12" sm="6">
                        <a :href="baseAttach + file._id" target="_blank">
                          {{ file.filename }}
                        </a>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-icon @click='deleteProofImages(file)'> delete</v-icon>
                      </v-col>
                    </v-row>
                  </v-col>

                </v-row>
              </v-col>
            </v-row>
            <span> Số tiền còn lại cần thu: <span
                class="totalFont"> {{ thousandSeprator(calculateMoneyHasToPay()) }} đ </span> </span>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkInforFinance" width="120px" class="mr-5">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="4" v-if="requestMethod == 2">
          <v-container>
            <v-row align="start" v-if="e1 === 4" no-gutters>
              <v-col cols="12" sm="6" class="pr-2">
                <v-row align="start" no-gutters>
                  <v-col cols="12">
                    <v-autocomplete v-model="selectOrderUnit" :items="orderUnits" item-text="displayString"
                                    v-bind:label="$t('order_unit.title')" outlined return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>{{ $t('tooltip_infor.oder_unit') }}</span>
                      </v-tooltip>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                                    v-bind:label="$t('profile.province')" outlined return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>{{ $t('tooltip_infor.select_province') }}</span>
                      </v-tooltip>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-select v-model="selectGift" :items="gifts" item-text="name"
                              v-bind:label="$t('manufacture_item.gift')" outlined multiple return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Chọn các quà tặng mà khách hàng đủ điền kiện nhận</span>
                      </v-tooltip>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea v-model="manufactureRequest.giftNote" v-bind:label="$t('manufacture_item.gift_note')"
                                outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Ghi chú về thông tin quà tặng</span>
                      </v-tooltip>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6" class="pl-2">
                <v-row align="start" no-gutters>
                  <v-col cols="12">
                    <v-text-field v-model="requestTitle" :rules="stringRules"
                                  v-bind:label="$t('design_manager.design_title')" outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Nhập tên yêu cầu thiết kế</span>
                      </v-tooltip>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete v-model="customerType" :items="customerTypes" item-text="name"
                                    v-bind:label="$t('design_item.customer_type')" outlined return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Chọn phân loại cho khách hàng</span>
                      </v-tooltip>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea v-model="manufactureRequest.shipNote" v-bind:label="$t('manufacture_item.ship_note')"
                                outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Ghi chú về thông tin ship</span>
                      </v-tooltip>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row align="start" no-gutters>
              <v-col cols="12">
                <upload-dialog @uploadFileSuccess="uploadFileGiftSuccess"></upload-dialog>
                <v-row v-for="file in giftImages" :key="file.id" no-gutters class="pl-5">
                  <v-col cols="12" sm="6">
                    <a :href="baseAttach + file._id" target="_blank">
                      {{ file.filename }}
                    </a>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-icon @click='deleteGiftImages(file)'> delete</v-icon>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>


            <v-row align="start" class="mt-10" no-gutters>
              <span
                  class="subTitleStyle">Bạn cần nhập số điện thoại hoặc facebook id để tìm kiếm thông tin khách hàng.</span>
            </v-row>
            <v-row align="start" no-gutters>
              <v-col cols="12" sm="5">
                <v-col>
                  <v-text-field v-model="customerInfor" v-bind:label="$t('create_design_request.phone_fb')" outlined
                                dense>
                    <v-tooltip slot="append-outer" bottom dark max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập số điện thoại hoặc facebook rồi bấm nút Tìm kiếm để tìm thông tin của khách hàng.
                                                Nếu không tồn tại khách hàng thì bấm tạo mới để thêm mới khách hàng</span>
                    </v-tooltip>
                  </v-text-field>
                </v-col>
              </v-col>
              <v-col>
                <v-col>
                  <v-btn color="primary" @click="getCustomerByPhone" width="120px" class="mr-5">
                    {{ $t('common.search') }}
                  </v-btn>

                  <v-btn color="primary" @click="showAddCustomer" width="120px" class="mr-5">
                    {{ $t('common.create') }}
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>

            <v-row align="start" no-gutters>
              <v-container align="center">
                <v-row align="start" justify="start">
                  <v-col v-for="item in customers" :key="item._id" :cols="6">
                    <v-card>
                      <v-card-title>
                        <span> {{ item.fullname }} </span>
                        <v-spacer></v-spacer>
                        <v-checkbox class="mb-5" v-model="customer" color="primary" :value="item"
                                    hide-details @click="chosenCustomer(item)">
                        </v-checkbox>
                      </v-card-title>

                      <v-card-text>
                        SĐT: {{ item.phone }}
                        <br/>
                        Facebook: {{ item.facebook }}
                        <br/>
                        Địa chỉ: {{ addressToString(item.defaultAddress) }}
                      </v-card-text>
                      <v-card-actions>

                        <v-spacer></v-spacer>

                        <!-- <v-btn icon> -->
                        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="editCustomerInfor(item)">edit</v-icon>
                          </template>
                          <span>Chỉnh sửa thông tin khách hàng</span>
                        </v-tooltip>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-row>

          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" width="120px" @click="checkShipInformation">
              {{ $t('common.continue') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="4" v-else>
          <v-container>
            <v-row align="start" v-if="e1 === 4" no-gutters>
              <v-col cols="12" sm="6" class="pr-2">
                <v-row align="start" no-gutters>
                  <v-col cols="12">
                    <v-select v-model="selectGift" :items="gifts" item-text="name"
                              v-bind:label="$t('manufacture_item.gift')" outlined multiple return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Chọn các quà tặng mà khách hàng đủ điền kiện nhận</span>
                      </v-tooltip>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea v-model="manufactureRequest.giftNote" v-bind:label="$t('manufacture_item.gift_note')"
                                outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Ghi chú về thông tin quà tặng</span>
                      </v-tooltip>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6" class="pl-2">
                <v-row align="start" no-gutters>
                  <v-col cols="12">
                    <v-autocomplete v-model="customerType" :items="customerTypes" item-text="name"
                                    v-bind:label="$t('design_item.customer_type')" outlined return-object dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Chọn phân loại cho khách hàng</span>
                      </v-tooltip>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea v-model="manufactureRequest.shipNote" v-bind:label="$t('manufacture_item.ship_note')"
                                outlined dense>
                      <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on">info</v-icon>
                        </template>
                        <span>Ghi chú về thông tin ship</span>
                      </v-tooltip>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row align="start" no-gutters>
              <v-col cols="12">
                <upload-dialog @uploadFileSuccess="uploadFileGiftSuccess"></upload-dialog>
                <v-row v-for="file in giftImages" :key="file.id" no-gutters class="pl-5">
                  <v-col cols="12" sm="6">
                    <a :href="baseAttach + file._id" target="_blank">
                      {{ file.filename }}
                    </a>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-icon @click='deleteGiftImages(file)'> delete</v-icon>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>

            <v-row align="start" class="pt-2">
              <v-col cols="12">
                <span class="font-weight-black pb-2">  {{ $t('detail_request.ship_infor') }} <v-icon class="pb-2"
                                                                                                     @click="editCustomer"> edit </v-icon> </span>
                <v-col>
                  <v-row>
                    <span class="pb-1"> {{ $t('detail_request.customer_infor') }} </span>
                  </v-row>
                  <v-row class="pb-1"> {{ $t('detail_request.fullname') }} {{ customer ? customer.fullname : '' }}
                  </v-row>
                  <v-row class="pb-1"> {{ $t('detail_request.phone') }} {{ customer ? customer.phone : '' }}</v-row>
                  <v-row class="pb-1">
                    {{ $t('detail_request.facebook') }} <a :href="customer ? customer.facebook : ''" target="_blank">
                    {{ customer ? (customer.facebook ? customer.facebook : '') : '' }} </a>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row>
                    <span class="pb-1"> {{ $t('detail_request.receiver_infor') }} </span>
                  </v-row>
                  <v-row class="pb-1"> {{ $t('detail_request.receiver') }}
                    {{ customer ? (customer.defaultAddress ? customer.defaultAddress.name : customer.fullname) : '' }}
                  </v-row>
                  <v-row class="pb-1"> {{ $t('detail_request.receive_phone') }}
                    {{ customer ? (customer.defaultAddress ? customer.defaultAddress.phone : customer.phone) : '' }}
                  </v-row>
                  <v-row class="pb-1"> {{ $t('detail_request.receive_address') }}
                    {{ addressToString(customer ? customer.defaultAddress : '') }}
                  </v-row>
                </v-col>
              </v-col>
            </v-row>

          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" width="120px" @click="checkShipInformation" v-if="isFreelancer">
              {{ $t('common.continue') }}
            </v-btn>
            <v-btn color="primary" @click="createManufactureRequest" width="120px" class="mr-5" v-else>
              {{ $t('common.done') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-container align="center" v-if="e1 === 5">
            <v-row align="start" no-gutters>
              <v-col cols="12">
                <upload-dialog @uploadFileSuccess="uploadDesignFileSuccess"></upload-dialog>
                <v-row v-for="file in designFiles" :key="file.id" no-gutters class="pl-5">
                  <v-col cols="12" sm="6">
                    <a :href="baseAttach + file._id" target="_blank">
                      {{ file.filename }}
                    </a>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-icon @click='deleteDesignFile(file)'> delete</v-icon>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>

            <v-row align="start" no-gutters class="mt-5">
              <span class="mr-5">Google Drive</span>
              <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on" @click="showGDrive()">cloud_upload</v-icon>
                </template>
                <span>Đính kèm từ Google Drive</span>
              </v-tooltip>

              <v-col cols="12">
                <v-row v-for="file in ggDriveLink" :key="file.id" no-gutters class="pl-5">
                  <v-col cols="12">
                    <a :href="file.url" target="_blank">
                      {{ file.name }}
                    </a>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>


          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="back">{{ $t('common.back') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="createManufactureRequest" width="120px" class="mr-5">
              {{ $t('common.done') }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialogAddStyleProfile" persistent max-width="70%">
      <v-stepper v-model="e2">
        <v-stepper-header>
          <v-stepper-step :complete="e2 > 1" step="1">Nhập thông tin sản phẩm</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e2 > 2" step="2">Nhập số lượng</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" sm="6" class="pr-2">
                  <v-autocomplete v-model="selectFormStyle" :items="formStyles" item-text="name"
                                  v-bind:label="$t('manufacture_item.form_style')" outlined return-object dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn kiểu áo để thiết kế và sản xuất</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" class="pl-2">
                  <v-autocomplete v-model="selectMaterial" :items="materialStyles" item-text="displayString"
                                  v-bind:label="$t('manufacture_item.material_style')" outlined return-object dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn nguyên vật liệu để sản xuất áo</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" class="pr-2">
                  <v-numeric-field v-model="editedDetailProfile.price" v-bind:label="$t('manufacture_item.cost')"
                                   outlined dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập giá cho sản phẩm</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col cols="12" sm="6" class="pl-2">
                  <v-numeric-field v-model="editedDetailProfile.giftNumber"
                                   v-bind:label="$t('manufacture_item.number_shirt')" outlined dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập số lượng áo tặng</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-textarea v-model="editedDetailProfile.tailorNote" v-bind:label="$t('design_item.tailor_note')"
                              outlined dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú may cho sản phẩm</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-textarea v-model="editedDetailProfile.printNote" v-bind:label="$t('design_item.print_note')"
                              outlined dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú in cho sản phẩm</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-textarea v-model="editedDetailProfile.financeNote" v-bind:label="$t('design_item.finance_note')"
                              outlined dense>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú tài chính cho sản phẩm</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

                <v-col cols="12" sm="6">
                  <upload-dialog @uploadFileSuccess="uploadFileSuccess"></upload-dialog>
                  <v-row v-for="file in uploadedFiles" :key="file._id">
                    <v-col cols="12" sm="6">
                      <a :href="baseAttach + file._id" target="_blank">
                        {{ file.filename }}
                      </a>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-icon @click='deleteImage(file)'> delete</v-icon>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>

            <v-divider></v-divider>
            <v-toolbar flat>
              <v-btn color="primary" width="120px" @click="closeAddProduct">{{ $t('common.cancel') }}</v-btn>

              <v-spacer></v-spacer>

              <v-btn color="primary" @click="checkInforProduct" class="mr-5">
                {{ $t('common.continue') }}
              </v-btn>
            </v-toolbar>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-container align="center">
              <v-row v-for="item in profiles" :key="item._id" no-gutters>
                <v-col cols="12" class="pb-2">
                  <span> {{ item.profile ? item.profile.name : 'NA' }} {{ ': ' + calculateProfile(item.sizes) }}</span>
                </v-col>

                <v-col cols="12" sm="1" v-for="size in item.sizes" :key="size._id" class="pr-1">
                  <v-numeric-field v-model="size.number" v-bind:label="getSizeName(size)" outlined dense>
                  </v-numeric-field>
                </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <span> Tổng số: <span class="header-title"> {{
                      calculateTotalSizeOfAllProfiles(profiles)
                    }}</span></span>
                </v-col>

              </v-row>
            </v-container>

            <v-divider></v-divider>
            <v-toolbar flat>
              <v-btn color="primary" width="120px" @click="backAddSizeProfile">{{ $t('common.back') }}</v-btn>

              <v-spacer></v-spacer>

              <v-btn color="primary" width="120px" @click="addProduct">{{ $t('common.done') }}</v-btn>
            </v-toolbar>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

    </v-dialog>

    <customer-dialog :showDialog="dialogAddCustomer" :editedItem="customer" :editedIndex="editedCustomerIndex"
                     @closeDialog="closeDialog" @updateCustomer="updateCustomer" v-if="customer">
    </customer-dialog>

    <rate-dialog :dialog="rateDialog" @closeDialog="closeRate" :targetUser="designer"></rate-dialog>

    <google-drive-select v-model="gDriveDialog" :editedItem="gDriveObject" @closeDialogGDrive="closeGDrive"
                         @cancelUploadGDrive="cancelGDrive"
                         v-if="gDriveObject">
    </google-drive-select>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
// import ImageInput from '@/components/ImageInput.vue';
import moment from 'moment';
import VNumericField from "@/components/VNumericField";
// import FileUpload from 'vue-upload-component';
import UploadDialog from "@/components/UploadDialog";
import CustomerDialog from "@/components/CustomerDialog";
import RateDialog from "@/components/RateDialog";
import GoogleDriveSelect from "@/components/GoogleDriveSelect";

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    modal: false,
    selectFileUploads: [],

    dialogAddCustomer: false,
    editedCustomerIndex: 0,
    rateDialog: false,

    gDriveDialog: false,
    gDriveObject: null,

    e1: 1,
    e2: 1,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    isShowStep2: false,
    isShowStep3: false,
    isShowStep4: false,
    isShowStep5: false,
    isFreelancer: false,

    designRequest: {},
    deadline: moment(String(new Date())).format("YYYY-MM-DD"),
    selectOrderType: {},
    orderTypes: [],
    editedDetailProfile: {},
    detailProfiles: [],

    designer: {},

    requestDetails: [],
    materialDetails: [],
    manufactureRequest: {},
    proofImage: {},

    gifts: [],
    selectGift: [],
    customerInfor: '',

    address: '',
    nameReceive: '',
    phoneReceive: '',

    customer: null,
    customers: [],

    customerType: {},
    customerTypes: [],

    selectFormStyle: '',
    formStyles: [],

    selectMaterial: '',
    materialStyles: [],

    dialogAddStyleProfile: false,
    selectProfile: null,
    profiles: [],
    sizes: [],
    isEditData: false,

    editedManufacture: {},
    isSaleEdited: false,
    isAccountantEdited: false,
    isReproduce: false,
    editedIndex: -1,
    requestMethod: 0,

    isTag: false,

    selectOrderUnit: null,
    orderUnits: [],
    requestTitle: '',

    selectProvince: null,
    provinces: [],

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],
    phoneRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
    ],
    emailRules: [
      v => !!v || i18n.t('validate.email_require'),
      v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
    ],
    addressRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 2) || i18n.t('validate.address_invalid'),
    ],
    numberRules: [
      v => !!v || i18n.t('validate.not_empty'),
    ],

    discount: 0,
    additionCost: 0,
    prepay: 0,
    vat: 0,

    finalPrice: 0,

    indexTypeImage: 0, //0: product, 1:proofImages, 2:giftImages

    uploadedFiles: [],
    proofImages: [],
    giftImages: [],
    files: [],
    designFiles: [],
    ggDriveLink: [],

    durationManufacture: 0,
    receiveDateString: '',
    receiveDate: moment(String(new Date())).format("YYYY-MM-DD"),
    shipType: 1,
  }),

  computed: {
    computedDateFormatted() {
      this.calculateDateDistance(this.deadline);
      this.formatReceviceDate(this.deadline);
      return this.formatDate(this.deadline);
    }
  },

  components: {
    VNumericField: VNumericField,
    UploadDialog: UploadDialog,
    CustomerDialog: CustomerDialog,
    RateDialog: RateDialog,
    GoogleDriveSelect: GoogleDriveSelect
  },

  watch: {
    dialogAddStyleProfile(val) {
      val || this.closeAddStyleProfile()
    },

    shipType(val) {
      val || this.formatReceviceDate(this.deadline);
    },

    selectFormStyle(val) {
      if (val.profiles && val.profiles.length > 0 && !this.isEditData) {
        this.profiles = [];

        val.profiles.forEach((profile) => {
          this.sizes = [];

          profile.sizes.forEach((item) => {
            const detail = {
              number: 0,
              size: item
            }

            this.sizes.push(detail);
          });

          const profileManufacture = {
            profile: profile,
            sizes: this.sizes
          }

          this.profiles.push(profileManufacture);
        });
      }
    },

    discount(val) {
      // if (val >= 0) {
      //     this.manufactureRequest.discount = val;
      //     this.calculateFinalTotal();
      // } else {
      //     this.discount = 0;
      // }
      if (val <= 0) {
        this.discount = 0;
      }
      this.manufactureRequest.discount = this.discount;
      this.calculateFinalTotal();
    },

    additionCost(val) {
      // if (val >= 0) {
      //     this.manufactureRequest.additionCost = val;
      //     this.calculateFinalTotal();
      // } else {
      //     this.additionCost = 0;
      // }
      if (val <= 0) {
        this.additionCost = 0;
      }
      this.manufactureRequest.additionCost = this.additionCost;
      this.calculateFinalTotal();
    },

    prepay(val) {
      // if (val >= 0) {
      //     this.manufactureRequest.prepay = val;
      // } else {
      //     this.prepay = 0;
      // }

      if (val <= 0) {
        this.prepay = 0;
      }

      this.manufactureRequest.prepay = this.prepay;
    },

    vat(val) {
      // if (val >= 0) {
      //     this.manufactureRequest.vat = val;
      //     this.calculateFinalTotal();
      // } else {
      //     this.vat = 0;
      // }
      if (val <= 0) {
        this.vat = 0;
      }

      this.manufactureRequest.vat = this.vat;
      this.calculateFinalTotal();
    },
  },

  async created() {
    this.getData();
    await Promise.all([
      this.getAllOrderType(),
      this.getAllFormStyles(),
      this.getMaterialStyles(),
      this.getCustomerType(),
      this.getOrderUnits(),
      this.getProvince()
    ]);
  },

  methods: {
    initialize() {
    },

    calculateDateDistance(deadline) {
      this.durationManufacture = 0;
      var startDate = new Date();
      const mannufactureDate = new Date(deadline)

      for (var date = startDate; date < mannufactureDate; date.setDate(date.getDate() + 1)) {
        if (date.getDay() !== 0) {
          this.durationManufacture++;
        }
      }
    },

    formatReceviceDate(deadline) {
      const mannufactureDate = new Date(deadline)

      if (this.shipType == 1) {
        const date = new Date(mannufactureDate.getTime() + 2 * 86400 * 1000);
        this.receiveDate = moment(String(date)).format("DD/MM/YYYY");
        this.receiveDateString = (date.getDate() - 1) + ' - ' + this.receiveDate;
      } else if (this.shipType == 2) {
        const date = new Date(mannufactureDate.getTime() + 4 * 86400 * 1000);
        this.receiveDate = moment(String(date)).format("DD/MM/YYYY")
        this.receiveDateString = (date.getDate() - 1) + ' - ' + this.receiveDate;
      } else {
        const date = new Date(mannufactureDate.getTime() + 2 * 86400 * 1000);
        this.receiveDate = moment(String(date)).format("DD/MM/YYYY");
        this.receiveDateString = (date.getDate() - 1) + ' - ' + this.receiveDate;
      }
    },

    closeRate(value) {
      this.rateDialog = value;
      this.close();
    },

    checkInforProgress() {
      this.isShowStep2 = true;
      this.e1 = 2;
    },

    closeDialog(value) {
      this.dialogAddCustomer = value
    },

    updateCustomer(value) {
      this.customer = value;

      if (this.editedCustomerIndex > -1) {
        Object.assign(this.customers[this.editedCustomerIndex], value);
      } else {
        this.customers = [];
        this.customers.push(value);
      }
    },

    editCustomer() {
      this.dialogAddCustomer = true;
    },

    editCustomerInfor(customer) {
      this.editedCustomerIndex = this.customers.indexOf(customer);
      this.customer = customer;
      this.dialogAddCustomer = true;
    },

    addressToString(detail) {
      if (detail && detail.fullDetail) {
        return detail.fullDetail;
      } else {
        return '';
      }
    },

    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    close() {
      if (this.isSaleEdited || this.requestMethod > 0) {
        this.$router.push('manufactureRequestManagement');
      } else if (this.isAccountantEdited) {
        this.$router.push('accountantManufactureRequest');
      } else if (this.isReproduce) {
        this.$router.push('finishRequestManagement');
      } else {
        this.$router.push('designRequestManagement');

        this.e1 = 1;
      }
    },

    closeAddStyleProfile() {
      this.dialogAddStyleProfile = false;
    },

    back() {
      if (this.e1 > 1) {
        this.e1 = this.e1 - 1;
      } else if (this.e2 > 1) {
        this.e2 = this.e2 - 1;
      }
    },

    backAddSizeProfile() {
      if (this.e2 > 1) {
        this.e2 = this.e2 - 1;
      }
    },

    async getAllOrderType() {
      try {
        const response = await this.$http.get('/orderType');
        if (response.data && response.data.success) {
          this.orderTypes = response.data.data;
          if (this.orderTypes.length > 0) {
            this.selectOrderType = this.orderTypes[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getAllGiftByNumber(numberProfile) {
      try {
        // const response = await this.$http.get('/gift');
        const response = await this.$http.get('/gift/query/0?number=' + numberProfile);
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.gifts = contextArr;
          // this.selectGift = this.gifts;
          // if (this.gifts.length > 0) {
          //     this.selectGift = this.gifts[0];
          // }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async uploadImage(data) {
      if (data.formData != null) {
        const response = await this.$httpUpload.post("/uploadImg/", data.formData);
        // console.log(response.data);
        if (response.data && response.data.id) {
          data.id = response.data.id;
        }
      }
    },

    checkInforFinance() {
      if (this.manufactureRequest.discount && parseInt(this.manufactureRequest.discount) < 0) {
        alert('Thông tin chiết khấu không đúng');
        return;
      }

      if (this.manufactureRequest.additionCost && parseInt(this.manufactureRequest.additionCost) < 0) {
        alert('Thông tin phụ thu không đúng');
        return;
      }


      if ((!this.manufactureRequest.discountNote || this.manufactureRequest.discountNote.length == 0) && parseInt(this.manufactureRequest.discount) > 0) {
        console.log(this.manufactureRequest.discount);
        alert('Chưa nhập giải thích chiết khấu');
        return;
      }

      if ((!this.manufactureRequest.additionCostNote || this.manufactureRequest.additionCostNote.length == 0) && parseInt(this.manufactureRequest.additionCost) > 0) {
        alert('Chưa nhập giải thích phụ thu');
        return;
      }

      if (this.manufactureRequest.total && parseInt(this.manufactureRequest.total) < 0) {
        alert('Thông tin doanh thu cuối không đúng');
        return;
      }

      if (this.manufactureRequest.prepay && parseInt(this.manufactureRequest.prepay) < 0) {
        alert('Thông tin đặt cọc không đúng');
        return;
      }

      this.isShowStep2 = false;
      this.isShowStep3 = false;
      this.isShowStep4 = true;
      this.e1 = 4;
    },

    checkShipInformation() {
      if (this.requestMethod == 2 && !this.selectOrderUnit) {
        alert('Chưa chọn Đơn vị đặt hàng');
        return;
      }

      if (this.requestMethod == 2 && this.requestTitle.length == 0) {
        alert('Chưa nhập tên yêu cầu');
        return;
      }

      if (!this.customer || !this.customer._id) {
        alert(i18n.t('design_item.warning_customer'));
        return;
      }

      if (!this.customer.defaultAddress) {
        alert('Chưa chọn thông tin địa chỉ vận chuyển');
        return;
      }



      this.isShowStep2 = false;
      this.isShowStep3 = false;
      this.isShowStep4 = false;
      this.isShowStep5 = true;
      this.e1 = 5;
    },

    async createManufactureRequestBySale() {
      if (this.designFiles.length === 0 && this.ggDriveLink.length === 0) {
        alert('Chưa đính kèm file thiết kế');
        return;
      }

      const agree = confirm(i18n.t('common.confirm_create_manufacture'));
      if (!agree) {
        return;
      }

      let requestBody = Object.assign({}, this.manufactureRequest);

      requestBody = {
        ...requestBody,
        customer: this.customer._id,
        orderType: this.selectOrderType._id,
        customerType: this.customerType,
        deadline: moment(String(this.deadline)).format("DD/MM/YYYY"),
        receiveDate: this.receiveDate,
        shipType: this.shipType,
        durationManufacture: this.durationManufacture,
        gifts: this.selectGift,
        proofImgs: this.proofImages,
        numberOfShirts: 1,
        giftImgs: this.giftImages,
        tag: this.isTag ? 'Dongia123' : '',
        request_details: this.detailProfiles,
        status: 2,
        // designerStatus: 2,
        accountantStatus: 1,
        requestMethod: this.requestMethod,
        requestTitle: this.requestTitle,
        orderUnit: this.selectOrderUnit,
        vtProvince: this.selectProvince,
      }

      requestBody.files = [].concat(this.designFiles);
      requestBody.gDrive = [].concat(this.ggDriveLink);

      if (this.requestMethod == 1 || this.requestMethod == 2) {
        requestBody.status = 2;
        requestBody.accountantStatus = 1;
      }

      try {
        const response = await this.$http.post('/manufactureRequest', requestBody);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.success'),
            text: "",
            type: "success"
          }).then(() => {
            this.close();
          });
        } else if (response.data && !response.data.success) {
          alert(response.data.message);
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
        alert(i18n.t('validate.request_error'));
      }
    },

    async createManufactureRequest() {
      if (this.requestMethod === 2) {
        await this.createManufactureRequestBySale();
        return;
      }

      const self = this;

      if (this.requestMethod === 1 && this.designFiles.length === 0 && this.ggDriveLink.length === 0) {
        alert('Chưa đính kèm file thiết kế');
        return;
      }

      const agree = confirm(i18n.t('common.confirm_create_manufacture'));
      if (!agree) {
        return;
      }

      let requestBody = Object.assign({}, this.manufactureRequest);
      // this.giftToSend.push(this.selectGift);

      requestBody = {
        ...requestBody,
        designRequest: this.designRequest._id,
        designer: this.designer._id,
        customer: this.customer._id,
        orderType: this.selectOrderType._id,
        customerType: this.customerType,
        deadline: moment(String(this.deadline)).format("DD/MM/YYYY"),
        receiveDate: this.receiveDate,
        shipType: this.shipType,
        durationManufacture: this.durationManufacture,
        gifts: this.selectGift,
        proofImgs: this.proofImages,
        numberOfShirts: 1,
        giftImgs: this.giftImages,
        tag: this.isTag ? 'Dongia123' : '',
        request_details: this.detailProfiles
      }

      requestBody.files = [].concat(this.designFiles);
      requestBody.gDrive = [].concat(this.ggDriveLink);

      if (this.requestMethod == 1 || this.requestMethod == 2) {
        requestBody.status = 2;
        // requestBody.designerStatus = 2;
        requestBody.accountantStatus = 1;
        requestBody.requestMethod = this.requestMethod;
      }

      if (self.isSaleEdited || this.isAccountantEdited) {
        const response = await this.$http.put('/manufactureRequest/' + this.manufactureRequest._id, requestBody);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.close();
          });
        } else if (response.data && !response.data.success) {
          alert(response.data.message);
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } else {
        if (this.isReproduce) {
          requestBody = {
            ...requestBody,
            baseRequest: this.manufactureRequest._id,
            requestType: 1,
            status: 2,
            designerStatus: 2,
            accountantStatus: 1
          }

          this.$delete(requestBody, 'code');
          this.$delete(requestBody, '_id');
          this.$delete(requestBody, 'createdAt');
          this.$delete(requestBody, 'shipCode');
          this.$delete(requestBody, 'totalEdit');
          this.$delete(requestBody, 'logisticStatus');
          this.$delete(requestBody, 'logisticUnit');
          this.$delete(requestBody, 'sendEmailStatus');
          this.$delete(requestBody, 'numberOfProductReceived');
        }

        try {
          const response = await this.$http.post('/manufactureRequest', requestBody);
          if (response.data && response.data.success) {
            this.$fire({
              title: i18n.t('common.success'),
              text: "",
              type: "success"
            }).then(() => {
              if (!this.isReproduce) {
                self.rateDialog = true;
              } else {
                this.close();
              }
            });
          } else if (response.data && !response.data.success) {
            alert(response.data.message);
          } else {
            alert(i18n.t('validate.request_error'));
          }
        } catch (e) {
          console.log(e.stack);
          alert(i18n.t('validate.request_error'));
        }
      }
    },

    async getAllProfile() {
      try {
        const response = await this.$http.get('/profile');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.profiles = contextArr;
          if (this.profiles.length > 0) {
            this.selectProfile = this.profiles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getAllFormStyles() {
      try {
        const response = await this.$http.get('/formStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.formStyles = contextArr;

          if (this.formStyles.length > 0) {
            this.selectFormStyle = this.formStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getMaterialStyles() {
      try {
        const response = await this.$http.get('/materialStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.materialStyles = contextArr;

          if (this.materialStyles.length > 0) {
            this.materialStyles.forEach(item => {
              item.displayString = this.createMaterialStyleStringDefault(item);
            });

            this.selectMaterial = this.materialStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    getData() {
      const receivedData = Object.assign({}, this.$route.params);
      this.detailProfiles = [];

      if (receivedData.createFromBill) {
        this.manufactureRequest = {};
        this.requestMethod = 2;
        this.customer = null;

        return;
      }

      if (receivedData.editedTarget && receivedData.editedManufacture) {
        if (receivedData.editedTarget === 1) {
          this.isSaleEdited = true;
        } else if (receivedData.editedTarget === 2) {
          this.isAccountantEdited = true;
        } else if (receivedData.editedTarget === 3) {
          this.isReproduce = true;
        }

        this.manufactureRequest = receivedData.editedManufacture;

        this.designRequest = this.manufactureRequest.designRequest;

        this.deadline = moment(this.manufactureRequest.deadline).format("YYYY-MM-DD");
        this.selectOrderType = this.manufactureRequest.orderType;

        this.detailProfiles = [].concat(this.manufactureRequest.request_details);

        this.discount = this.manufactureRequest.discount ? this.manufactureRequest.discount : 0;
        this.additionCost = this.manufactureRequest.additionCost ? this.manufactureRequest.additionCost : 0;
        this.vat = this.manufactureRequest.vat ? this.manufactureRequest.vat : 0;
        this.prepay = this.manufactureRequest.prepay ? this.manufactureRequest.prepay : 0;
        this.finalPrice = this.manufactureRequest.total ? this.manufactureRequest.total : 0;

        this.shipType = this.manufactureRequest.shipType ? this.manufactureRequest.shipType : 1;
        this.durationManufacture = this.manufactureRequest.durationManufacture ? this.manufactureRequest.durationManufacture : 0;
        // this.receiveDate = this.manufactureRequest.receiveDate ? moment(String(this.manufactureRequest.receiveDate)).format("YYYY-MM-DD") : 0;

        this.giftImages = this.manufactureRequest.giftImgs;
        this.proofImages = this.manufactureRequest.proofImgs;
        this.isTag = (this.manufactureRequest.tag === '' || !this.manufactureRequest.tag) ? false : true;

        if (Array.isArray(this.manufactureRequest.gifts) && this.manufactureRequest.gifts.length > 0) {
          this.selectGift = this.manufactureRequest.gifts;
        }

        this.customer = this.manufactureRequest.customer;
        this.customerType = this.manufactureRequest.customerType;
        this.designer = this.manufactureRequest.designer;
        // this.requestDetails = this.manufactureRequest.designRequest.request_details;

        this.designFiles = [].concat(this.manufactureRequest.files);
        this.ggDriveLink = [].concat(this.manufactureRequest.gDrive);
      } else {
        this.designRequest = this.$route.params;
        // this.requestDetails = this.designRequest.request_details;
        this.customer = this.designRequest.customer;
        this.customerType = this.designRequest.customerType;
        this.designer = this.designRequest.designer;
      }

      this.requestMethod = this.manufactureRequest.requestMethod;
      this.isFreelancer = this.manufactureRequest.requestMethod === 1 ? true : false;

      if (this.customer && this.customer.defaultAddress) {
        this.addresses = this.customer.addresses;

        const defaultAddress = this.customer.defaultAddress;
        this.nameReceive = defaultAddress.name;
        this.phoneReceive = this.customer.phone;
        this.address = defaultAddress.detail;
        this.selectDistrict = defaultAddress.province[0];
        this.selectProvince = defaultAddress.province[1];

        setTimeout(() => this.selectedAddressDefault = this.customer.defaultAddress, 200);
      }

    },

    createHeaderStyle(detail) {
      return detail.formStyle.name + " - " + detail.materialStyle.material.name + " - " + detail.materialStyle.color_name;
    },

    createMaterialStyleString(detail) {
      if (!detail.materialStyle) {
        return '--';
      }
      return detail.materialStyle.material.name + " - " + detail.materialStyle.color_name + ' (' + detail.materialStyle.code + ')';
    },

    createMaterialStyleStringDefault(detail) {
      if (!detail) {
        return '--';
      }
      return detail.code + ' (' + detail.material.name + " - " + detail.color_name + ')';
    },

    addProductionInfor() {
      this.editedIndex = -1;
      this.selectFormStyle = this.formStyles[0];
      this.selectMaterial = this.materialStyles[0];

      this.editedDetailProfile = {};
      this.editedDetailProfile.price = 0;
      this.editedDetailProfile.giftNumber = 0;


      if (this.selectFormStyle.profiles && this.selectFormStyle.profiles.length > 0) {
        this.profiles = [];

        this.selectFormStyle.profiles.forEach((profile) => {
          this.sizes = [];

          profile.sizes.forEach((item) => {
            const detail = {
              number: 0,
              size: item
            }

            this.sizes.push(detail);
          });

          const profileManufacture = {
            profile: profile,
            sizes: this.sizes
          }

          this.profiles.push(profileManufacture);
        });
      }

      this.files = [];
      this.uploadedFiles = [];

      this.dialogAddStyleProfile = true;
      // this.dialogAddStyleProfile = true;
    },

    addProduct() {
      this.editedDetailProfile.profilesInfo = this.profiles;

      if (this.calculateTotalSizeOfProduct(this.editedDetailProfile) == 0) {
        alert("Chưa nhập số lượng!");
        return;
      }


      if (this.editedIndex > -1) {
        Object.assign(this.detailProfiles[this.editedIndex], this.editedDetailProfile);
      } else {
        this.detailProfiles.push(this.editedDetailProfile);
      }

      console.log(this.editedDetailProfile);

      this.isEdited = false;
      this.editedDetailProfile = {};
      this.e2 = 1;
      this.dialogAddStyleProfile = false;
    },

    checkInforProduct() {
      if (!this.uploadedFiles || this.uploadedFiles.length == 0) {
        alert("Chưa đính kèm file minh họa");
        return;
      }

      if (!this.editedDetailProfile.price || this.editedDetailProfile.price < 0) {
        alert("Chưa nhập đơn giá hoặc đơn giá sai định dạng!");
        return;
      }

      this.editedDetailProfile.formStyle = this.selectFormStyle;
      this.editedDetailProfile.materialStyle = this.selectMaterial;
      this.editedDetailProfile.files = [].concat(this.uploadedFiles);

      this.e2 = 2;
    },

    // generateProfileSizes(sizes) {
    //     let data = '';

    //     sizes.forEach(item => {
    //         if (item.number > 0) {
    //             data = data + item.number + '-' + item.size.name + ';';
    //         }
    //     });

    //     return data;
    // },

    generateProfileSizes(profile) {
      let data = '';

      profile.sizes.forEach(item => {
        if (item.number > 0) {
          data = data + item.number + '-' + item.size.name + '; ';
        }
      });

      return profile.profile.name + '(' + this.calculateProfile(profile.sizes) + ' chiếc): ' + data;
    },

    editProductInfor(detail) {
      this.isEditData = true;
      this.uploadedFiles = [];

      this.editedIndex = this.detailProfiles.indexOf(detail);
      this.editedDetailProfile = detail;
      this.profiles = detail.profilesInfo;

      detail.materialStyle.displayString = this.createMaterialStyleStringDefault(detail.materialStyle);

      this.selectMaterial = detail.materialStyle;
      this.selectFormStyle = detail.formStyle;
      console.log(this.isEditData);
      // setTimeout(() => this.sizes = detail.sizes, 200);

      this.uploadedFiles = this.editedDetailProfile.files;
      this.dialogAddStyleProfile = true;

      setTimeout(() => this.isEditData = false, 500);
    },

    deleteProductInfor(detail) {
      this.detailProfiles.splice(detail.index - 1, 1);
    },

    closeAddProduct() {
      this.e2 = 1;
      this.dialogAddStyleProfile = false;
    },

    checkAddProductionInfor() {
      if (!this.detailProfiles || this.detailProfiles.length == 0) {
        alert('Chưa thêm thông tin sản phẩm');
      } else {
        this.isShowStep2 = false;
        this.isShowStep3 = true;
        this.getAllGiftByNumber(this.calculateTotalSizeOfAll());
        this.e1 = 3;
      }
    },

    getAvailableSize(sizes) {
      return sizes.filter(item => item.number > 0);
    },

    calculateTotalSizeOfAll() {
      let total = 0;
      this.detailProfiles.forEach(detail => {
        total = total + this.calculateTotalSizeOfProduct(detail);
      });

      return total;
    },

    calculateTotalSizeOfProduct(detail) {
      let total = 0;
      detail.profilesInfo.forEach(item => {
        total = total + this.calculateProfile(item.sizes);
      });

      return total;
    },

    calculateTotalSizeOfAllProfiles(profiles) {
      let total = 0;
      profiles.forEach(item => {
        total = total + this.calculateProfile(item.sizes);
      });

      return total;
    },

    calculateTotalMoneyOfProduct(detail) {
      return (this.calculateTotalSizeOfProduct(detail) - detail.giftNumber) * parseInt(detail.price, 10);
    },

    calculateProfile(sizes) {
      let total = 0;
      sizes.forEach(size => {
        if (!size.number) {
          size.number = 0;
        } else {
          total = total + parseInt(size.number, 10);
        }
      });

      return total;
    },

    calculateTotalMoneyOfAll() {
      let total = 0;
      this.detailProfiles.forEach(detail => {
        total = total + this.calculateTotalMoneyOfProduct(detail);
      });

      this.manufactureRequest.subTotal = total;
      this.manufactureRequest.total = total;

      this.calculateFinalTotal();
      return total;
    },

    calculateFinalTotal() {
      const totalVAT = this.manufactureRequest.subTotal + parseInt(this.additionCost) - parseInt(this.discount);

      this.finalPrice = totalVAT + parseInt(totalVAT * this.vat / 100);
      this.manufactureRequest.total = this.finalPrice;
    },

    calculateMoneyHasToPay() {
      const prepay = this.manufactureRequest.prepay ? this.manufactureRequest.prepay : 0;
      return this.manufactureRequest.total - prepay;
    },

    async getCustomerType() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_CUSTOMER_TYPE_API);
        if (response.data && response.data.success) {
          this.customerTypes = response.data.data;
          if (this.customerTypes.length > 0) {
            this.customerType = this.customerTypes[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getOrderUnits() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_ORDER_UNIT_API);
        if (response.data && response.data.success) {
          this.orderUnits = [].concat(response.data.data);
          if (this.orderUnits.length > 0) {
            this.orderUnits.forEach(item => {
              item.displayString = this.createOrderUnitString(item);
            });
          }

          // if (this.orderUnits.length > 0) {
          //     this.selectOrderUnit = this.orderUnits[0];
          // }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    createOrderUnitString(item) {
      if (!item) {
        return '--';
      }
      return item.name + ' - ' + item.vtProvince.province_name + (item.description ? (' (' + item.description + ')') : '');
    },

    async getCustomerByPhone() {
      this.addresses = [];
      this.customer = {};
      this.customers = [];
      this.isShow = false;
      this.selectedAddressDefault = {};
      const self = this;
      // this.selectDistrict = this.districts[0];

      if (this.customerInfor.trim().length == 0) {
        alert('Chưa nhập thông tin');
        return;
      }
      try {
        // const response =  await self.$http.get('/customer/phone/' + self.customerPhone);
        const response = await self.$http.get(process.env.VUE_APP_CUSTOMER_QUERY_API + self.customerInfor.trim());

        if (response.data && response.data.success) {
          if (response.data.data.length == 0) {
            alert('Không có khách hàng nào')
          } else {
            this.customers = response.data.data;
          }

        } else if (response.data && !response.data.success) {
          alert(response.data.message);
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    getSizeName(detail) {
      if (detail.size) {
        return detail.size.name
      }
    },

    getImageProduct(detail) {
      if (detail.files.length > 0) {
        return this.baseAttach + detail.files[0]._id;
      }
      return '';
    },

    uploadFileSuccess(value) {
      this.uploadedFiles = this.uploadedFiles.concat(value);
    },

    deleteImage(file) {
      if (Array.isArray(this.uploadedFiles) && this.uploadedFiles.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          console.log(file);
          this.uploadedFiles.splice(this.uploadedFiles.indexOf(file), 1);
        }
      }
    },

    uploadFileProofSuccess(value) {
      this.proofImages = this.proofImages.concat(value);
    },

    deleteProofImages(file) {
      if (Array.isArray(this.proofImages) && this.proofImages.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          this.proofImages.splice(this.proofImages.indexOf(file), 1);
        }
      }
    },

    uploadFileGiftSuccess(value) {
      this.giftImages = this.giftImages.concat(value);
    },

    uploadDesignFileSuccess(value) {
      this.designFiles = this.designFiles.concat(value);
    },

    deleteDesignFile(file) {
      if (Array.isArray(this.designFiles) && this.designFiles.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          this.designFiles.splice(this.designFiles.indexOf(file), 1);
        }
      }
    },

    deleteGiftImages(file) {
      if (Array.isArray(this.giftImages) && this.giftImages.length > 0) {
        const agree = confirm(i18n.t('common.confirm_delete'));
        if (agree) {
          this.giftImages.splice(this.giftImages.indexOf(file), 1);
        }
      }
    },

    thousandSeprator(amount) {
      if (!amount) {
        return '0';
      }

      if (amount !== '' || amount !== 0 || amount !== '0' || amount !== null) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return amount;
      }
    },

    showGDrive() {
      this.gDriveObject = {
        gDrive: this.ggDriveLink
      };
      this.gDriveDialog = true;
    },

    closeGDrive(value) {
      this.gDriveDialog = value;
      this.ggDriveLink = [].concat(this.gDriveObject.gDrive);

      this.gDriveObject = null;
    },

    cancelGDrive(value) {
      this.gDriveDialog = value;
      this.gDriveObject = null;
    },

    showAddCustomer() {
      this.customer = {};
      this.editedCustomerIndex = -1;
      this.dialogAddCustomer = true;
    },

    chosenCustomer(customer) {
      this.customer = customer;
    },

    async getProvince() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
        if (response.data && response.data.success) {
          this.provinces = response.data.data;
          this.selectProvince = this.provinces[0];
        }
      } catch (e) {
        console.log(e.stack);
      }
    },
  },
}
</script>


<style>
.avataraBorder {
  border: 4px solid #F08942
}

.summaryFont {
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  color: #F08942;
}

.totalFont {
  font-size: 24px;
  font-style: normal;
  font-weight: normal;
  color: #000000;
}

.numberFont {
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  color: #000000;
}

.hintFont {
  color: #FF0000;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
}

.titleFont {
  color: #000000;
  font-size: 16px;
}
</style>